import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Button, DrawerBodyWrapper, DrawerFooterWrapper, MultiSelect, TOAST_TYPE } from '@base'
import { strings } from '@constants'
import { editTenderMaster } from '@data'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'

const EditTenderMaster = ({ data, update }) => {
	const dispatch = useDispatch()
	const [keywords, setKeywords] = useState([])
	const user = useSelector((_s) => _s.getIn(['user', 'user']))

	useEffect(() => {
		setKeywords(data?.keywords?.map((item) => ({ key: item })))
	}, [data])

	const onChangeHandler = (val) => {
		setKeywords(val)
	}

	const submitHandler = () => {
		const obj = { ...data, keywords: [...keywords?.map((item) => item.key)] }
		dispatch(showLoader(true))
		editTenderMaster(obj, user?.mobile_number)
			.then((response) => {
				dispatch(showToast(true, strings('msg_tender_master_keywords_updated'), { type: TOAST_TYPE.SUCCESS }))
				update()
			})
			.catch((error) => {
				let error_msg = error?.message ?? strings('msg_tender_master_keywords_failure')
				dispatch(showToast(true, error_msg, { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => {
				dispatch(toggleDrawer(false))
				dispatch(showLoader(false))
			})
	}

	return (
		<>
			<DrawerBodyWrapper>
				<MultiSelect
					id={'keywords'}
					label={strings('keywords')}
					placeholder={strings(['enter', 'keywords'])}
					data={[]}
					primaryKey={'key'}
					displayKey={'key'}
					value={keywords}
					onChange={onChangeHandler}
					createNewOption
				/>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button small onClick={submitHandler}>
					{strings('submit')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default EditTenderMaster
